import { IOpenClose } from '@interfaces/common';

export interface INotificationModalProps extends IOpenClose {
  dietarySupplementInModal: { [key: string]: string | number } | null;
  onExited: () => void;
}

export enum TSupplementType {
  INQUIRY,
  INQUIRY_ITEM,
}
